module.exports = __webpack_public_path__ + "static/media/loader.900cddf1.gif";